import ViewReportPage from "@/apps/data-platform/modules/report_management/viewReportPage/ViewReportPage.vue";
export default {
  components: {
    ViewReportPage: ViewReportPage
  }
};